import { render, staticRenderFns } from "./CarGallery.vue?vue&type=template&id=2d962a13"
import script from "./CarGallery.vue?vue&type=script&lang=js"
export * from "./CarGallery.vue?vue&type=script&lang=js"
import style0 from "./CarGallery.vue?vue&type=style&index=0&id=2d962a13&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports